import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { logIn } from "../../Service/login.service";
import { useAuth } from '../../main-component/context/AuthContext';
import './style.scss';
import HeaderTop from '../../components/HeaderTop/HeaderTop';

const LoginPage = () => {
    const { updateAuthState } = useAuth();
    const [formData, setFormData] = useState({
        user_email: '',
        user_password_value: ''
    });
    const [errors, setErrors] = useState({
        email: '',
        password: '',
        server: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const decodeTokenPayload = (token) => {
  if (!token) return {};
  
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return {};
    
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    
    const decoded = JSON.parse(jsonPayload);
    console.log('Decoded token:', decoded);  // Debug
    return decoded;
  } catch (error) {
    console.error('Token decode error:', error);
    return {};
  }
};
    const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setErrors({ email: '', password: '', server: '' });

  try {
    // 1. Make API call
    const response = await logIn(formData);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    
    const data = await response.json();
    console.log('API Response:', data);

    // 2. Validate response structure
    if (data.status !== "success" || !data.data?.user_token) {
      throw new Error(data.message || "Invalid response structure");
    }

    // 3. Decode token to get user role
    const decodedToken = decodeTokenPayload(data.data.user_token);
    console.log('Decoded Token:', decodedToken);

    // 4. Create user data object
    const userData = {
      token: data.data.user_token,
      user_role: data.data.user_role ?? decodedToken.user_role,
      user_id: data.data.user_id ?? decodedToken.user_id,
      user_firstName: data.data.user_firstName ?? decodedToken.user_firstName
    };

    if (!userData.user_role) {
      throw new Error("User role not found in response or token");
    }

    // 5. Save and update state
    localStorage.setItem("user", JSON.stringify(userData));
    updateAuthState(userData);
    console.log('Stored userData:', userData);

    // 6. Redirect
    window.location.href = Number(userData.user_role) === 4 
      ? "/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e" 
      : "/shop";

  } catch (error) {
    console.error('Login failed:', error);
    setErrors(prev => ({
      ...prev,
      server: error.message || "Login failed. Please try again."
    }));
  } finally {
    setIsLoading(false);
  }
};

    return (
       <>
       <HeaderTop/>
        <Grid className="loginWrapper">
            <Grid className="loginForm">
                <h2>Sign In</h2>
                <p>Sign in to your account</p>
                
                {errors.server && (
                    <div className="errorMessage server-error">
                        {errors.server}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                placeholder="Email"
                                name="user_email"
                                value={formData.user_email}
                                onChange={handleChange}
                                error={!!errors.email}
                                helperText={errors.email}
                                variant="outlined"
                                disabled={isLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                placeholder="Password"
                                name="user_password_value"
                                type="password"
                                value={formData.user_password_value}
                                onChange={handleChange}
                                error={!!errors.password}
                                helperText={errors.password}
                                variant="outlined"
                                disabled={isLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ py: 2 }}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Logging in...' : 'Login'}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between">
                                <Link to="/forgot-password">Forgot password?</Link>
                                <Link to="/register">Create an account</Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </Grid>
       </>
    );
};

export default LoginPage;